import * as DL from './../DL/Attendance';

/**
 * BUSINESS LOGIC (BL): ATTENDANCE (Registro de Asistencia)
 */

export const GetConfig = async () => {
    return await DL.GetConfig();
};

export const SaveConfig = async (data) => {
    return await DL.SaveConfig(data);
};

export const RegisterAttendance = async (subscriberCode) => {
    return await DL.RegisterAttendance(subscriberCode);
};

export const GetRecords = async () => {
    return await DL.GetRecords();
};

export const DeleteRecord = async (id) => {
    return await DL.DeleteRecord(id);
};
